import React, { Suspense, useState, useEffect } from 'react';
import { Button, Container, Spinner } from 'reactstrap';
import { Redirect, Route, Switch } from 'react-router-dom';
import CONSTANTS from 'utils/CONSTANTS';
import ViewTable from 'utils/ReactTableCards';
import {
  addSymptoms,
  deleteSymptoms,
  editSymptoms,
  getAllSymptoms,
} from 'utils/API/api';
import AddNewModalWithOutButton from 'components/advisor/add-new-Modal-with-out-button';
import IntlMessages from 'helpers/IntlMessages';
import AlertPopup from 'components/alert-popup';

const Symptoms = ({ match }) => {
  const [symptomsList, setSymptomsList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [symptomsData, setSymptomsData] = useState({});
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const handleDeleteSymptoms = (symptomsId) => {
    setDeleteId(symptomsId);
    setIsConfirmationOpen(true);
  };

  const confirmDeleteSymptoms = async () => {
    if (deleteId) {
      const res = await deleteSymptoms(deleteId);
      if (res !== -1) {
        setRefresh((previous) => !previous);
        setIsConfirmationOpen(false);
      }
    }
  };

  const handleEditSymptoms = (editValue) => {
    if (editValue) {
      setSymptomsData({ ...editValue });
      setEditModalOpen(true);
    }
  };

  useEffect(() => {
    (async () => {
      setLoading(false);
      const res = await getAllSymptoms();
      if (res !== -1) {
        setSymptomsList(
          res?.data?.data.map((symptomsItem, index) => {
            return {
              no: index + 1,
              ...symptomsItem,
              deleteData: {
                buttonLabel: 'Delete',
                id: symptomsItem?.id,
                onClick: handleDeleteSymptoms,
              },
              editData: {
                buttonLabel: 'Edit',
                id: {
                  ...symptomsItem,
                },
                onClick: handleEditSymptoms,
              },
            };
          })
        );
      }
    })();
  }, [refresh]);

  const prepareFormData = (e) => {
    const payload = {};
    CONSTANTS.RIGHT_SIDEBAR_FIELD.SYMPTOMS_MODAL.forEach((field) => {
      const tempValue = e.target[field.name].value;
      if (tempValue) {
        payload[field.name] = tempValue;
      }
    });

    return payload;
  };

  const editSymptomsHandler = (e) => {
    e.preventDefault();
    (async () => {
      if (symptomsData?.id) {
        const formData = prepareFormData(e);

        setLoading(true);
        const res = await editSymptoms(symptomsData?.id, formData);
        if (res !== -1) {
          setRefresh((previous) => !previous);
          setEditModalOpen(!editModalOpen);
        }
        setLoading(false);
      }
    })();
  };

  const addSymptomsHandler = (e) => {
    e.preventDefault();
    (async () => {
      const formData = prepareFormData(e);

      setLoading(true);
      const res = await addSymptoms(formData);
      if (res !== -1) {
        setRefresh((previous) => !previous);
        setModalOpen(!modalOpen);
      }
      setLoading(false);
    })();
  };

  return (
    <Suspense fallback={<div className="loading" />}>
      <Switch>
        <Route
          path={`${match.url}`}
          exact
          render={() =>
            !loading ? (
              <>
                <Container
                  style={{
                    display: 'flex',
                    justifyContent: 'end',
                    maxWidth: '100%',
                    margin: '0px',
                    padding: '0',
                    marginTop: '-10px',
                    marginBottom: '15px',
                    marginLeft: '-27px',
                  }}
                >
                  <Button
                    outline
                    color="primary"
                    className="top-right-button"
                    onClick={() => setModalOpen(true)}
                  >
                    <IntlMessages id={CONSTANTS.TABLE_ID.addSymptoms} />
                  </Button>
                </Container>
                <AddNewModalWithOutButton
                  sidebarMenu="SYMPTOMS_MODAL"
                  modalTitle={CONSTANTS.TABLE_ID.addSymptoms}
                  modalOpen={modalOpen}
                  toggleModal={() => setModalOpen(!modalOpen)}
                  onSubmit={addSymptomsHandler}
                  formData={{}}
                />

                <AddNewModalWithOutButton
                  sidebarMenu="SYMPTOMS_MODAL"
                  modalTitle={CONSTANTS.TABLE_ID.editSymptoms}
                  modalOpen={editModalOpen}
                  toggleModal={() => setEditModalOpen(!editModalOpen)}
                  onSubmit={editSymptomsHandler}
                  formData={symptomsData}
                />

                <ViewTable
                  headers={CONSTANTS.TABLE_HEADER.SYMPTOMS_LIST}
                  items={symptomsList}
                  advisorId={CONSTANTS.TABLE_ID.symptoms}
                  filterParams="name"
                />

                <AlertPopup
                  isOpen={isConfirmationOpen}
                  positiveText="Yes"
                  negativeText="No"
                  warning="Are you sure you want to delete?"
                  onNegative={() => {
                    setIsConfirmationOpen(false);
                    setDeleteId(null);
                  }}
                  onPositive={confirmDeleteSymptoms}
                />
              </>
            ) : (
              <>
                <Container className="d-flex justify-content-center align-items-center">
                  <Spinner
                    animation="border"
                    className="d-inline-flex m-2 "
                    color="$theme-color-yellow-granola"
                  />
                </Container>
              </>
            )
          }
        />
        <Redirect to="/error" />
      </Switch>
    </Suspense>
  );
};
export default Symptoms;
